import React from "react";
import Link from "next/link";
import { Box } from "@mui/material";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

interface DownloadBoxProps {
  href: string;
  style?: React.CSSProperties;
}

const DownloadBox: React.FC<DownloadBoxProps> = ({ href }) => (
  <Box
    component={Link}
    href={href ?? "#"}
    className="bf-ui"
    aria-label="Download PDF"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      px: 0.3125,
      fontFamily: FONT_UI,
      fontSize: "0.625rem",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      lineHeight: 1.7,
      color: "custom.newsprint",
      backgroundColor: "custom.kicker",
      textDecoration: "none",
      border: "1px solid",
      borderColor: "custom.kicker",
      "&:hover": {
        color: "custom.newsprint",
        backgroundColor: "custom.ink",
        borderColor: "custom.ink",
      },
    }}
  >
    PDF
  </Box>
);

export default DownloadBox;
